import { InjectionToken } from '@angular/core';

export const GOOGLE_ANALYTICS_ID = new InjectionToken<string>('GOOGLE_ANALYTICS_ID');
export const GOOGLE_TAG_MANAGER_ID = new InjectionToken<string>('GOOGLE_TAG_MANAGER_ID');
export const GA4_MEASUREMENT_ID = new InjectionToken<string>('GA4_MEASUREMENT_ID');
